import constants from "../../Utils/constants";
import bagImg from "../../assets/img/employeSVG.svg";
import CheckIcon0 from "../../assets/img/checkIcon02.svg";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";

const DetailsEmploymentInfo = (props) => {
  const {
    user = null,
    forensicAnalysis = {},
    handleInfoModal,
    isFromReport,
    currentLang,
  } = props;
  const llShowOnly = localStorage.getItem("usertype") == "landlord";

  const { _t } = useTranslator();

  const getEmploymentStatus = () => {
    if (user?.employment_status == constants.employed) {
      return _t("employed");
    }
    if (user?.employment_status == constants.self_employed) {
      return _t("selfEmployed");
    }
    if (user?.employment_status == constants.student) {
      return _t("student");
    }
    if (user?.employment_status == constants.unemployed) {
      return _t("unemployed");
    }
    if (user?.employment_status == constants.retired) {
      return _t("retired");
    }
    if (user?.employment_status == constants.public_servant) {
      return _t("publicServant");
    }
  };

  const employementType = haveValue(
    forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
  )
    ? forensicAnalysis?.["Employment Type"]?.dataInJSON?.employmentType
    : user?.employment_status;

  return (
    <>
      <div className={`main_doc_div ${isFromReport ? "h-100" : "mt-3"}`}>
        <div className="d-flex align-items-center gap-2 BorderB2">
          <img src={bagImg} alt="Vector Icon" className="vactorImg2" />
          <p className="docheader">{_t("employmentInformation")}</p>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div
              className={`Indo_form BorderB2 ${
                haveValue(forensicAnalysis?.["Employment Type"]) && llShowOnly
                  ? "cursor-pointer custom-tooltip"
                  : ""
              }`}
              data-tooltip={_t("clickHereToSeeDetails")}
              onClick={(e) => {
                if (
                  haveValue(forensicAnalysis?.["Employment Type"]) &&
                  llShowOnly
                ) {
                  handleInfoModal(forensicAnalysis?.["Employment Type"]);
                }
              }}
            >
              <div className="d-flex align-items-center gap-1">
                <p className="formlabel d-block">{_t("employmentStatus")}</p>
                <div className=" d-flex align-items-center gap-1">
                  {forensicAnalysis?.["Employment Type"]?.verifiedSource ==
                  true ? (
                    <img
                      src={CheckIcon0}
                      alt="Vector Icon"
                      className="validationIcon"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <p className="placeholderTest">
                {haveValue(
                  forensicAnalysis?.["Employment Type"]?.dataInJSON
                    ?.employmentType,
                )
                  ? _t(
                      forensicAnalysis?.["Employment Type"]?.dataInJSON
                        ?.employmentType,
                    )
                  : getEmploymentStatus()}
              </p>
            </div>
          </div>
          {user?.forensic_status === "COMPLETED" ? (
            <>
              {!(employementType ?? "")
                .toLowerCase()
                ?.includes(constants.student) ? (
                <div
                  className={`col-md-4 ${
                    haveValue(forensicAnalysis?.["Employment History"]) &&
                    llShowOnly
                      ? "cursor-pointer custom-tooltip"
                      : ""
                  }`}
                  data-tooltip={_t("clickHereToSeeDetails")}
                  onClick={(e) => {
                    if (
                      haveValue(forensicAnalysis?.["Employment History"]) &&
                      llShowOnly
                    ) {
                      handleInfoModal(forensicAnalysis?.["Employment History"]);
                    }
                  }}
                >
                  <div className="Indo_form BorderB2 ">
                    <div className=" d-flex align-items-center gap-1">
                      <p className="formlabel d-block">{_t("employerName")}</p>
                      {forensicAnalysis?.["Employment History"]
                        ?.verifiedSource == true ? (
                        <img
                          src={CheckIcon0}
                          alt="Vector Icon"
                          className="validationIcon"
                        />
                      ) : (
                        ""
                      )}
                    </div>

                    <p className="placeholderTest">
                      {(
                        forensicAnalysis?.[
                          "Employment History"
                        ]?.dataInJSON?.employmentHistory?.find(
                          (item) => item?.isCurrentEmployer,
                        ) ||
                        forensicAnalysis?.["Employment History"]?.dataInJSON
                          ?.employmentHistory?.[0]
                      )?.employerName || _t("na")}
                    </p>
                  </div>
                </div>
              ) : (
                <div className="col-md-4">
                  <div
                    className={`Indo_form BorderB2  ${
                      haveValue(forensicAnalysis?.["University Name"]) &&
                      llShowOnly
                        ? "cursor-pointer custom-tooltip"
                        : ""
                    }`}
                    data-tooltip={_t("clickHereToSeeDetails")}
                    onClick={(e) => {
                      if (
                        haveValue(forensicAnalysis?.["University Name"]) &&
                        llShowOnly
                      ) {
                        handleInfoModal(forensicAnalysis?.["University Name"]);
                      }
                    }}
                  >
                    <div className=" d-flex align-items-center gap-1">
                      <p className="formlabel d-block">
                        {_t("universityName")}
                      </p>
                      <div className=" d-flex align-items-center gap-1">
                        {forensicAnalysis?.["University Name"]
                          ?.verifiedSource == true ? (
                          <img
                            src={CheckIcon0}
                            alt="Vector Icon"
                            className="validationIcon"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>

                    <p className="placeholderTest">
                      {forensicAnalysis?.["University Name"]?.dataInJSON
                        ? forensicAnalysis?.["University Name"]?.dataInJSON
                            ?.universityName
                        : _t("na")}
                    </p>
                  </div>
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default DetailsEmploymentInfo;
